export default {
  selectKf: "请选择客服",
  table: {
    name: "昵称",
    username: "用户名",
    avatar: "头像",
    introduction: "简介",
    status: "状态",
    totalConversation: "会话数",
    avgResponseTime: "平均响应时长(s)",
    avgFinishTime: "平均会话时长(s)",
    scoreCnt: "用户评分人数",
    scoreAvg: "平均用户评分",
    createdAt: "创建时间",
    editTag: "编辑标签",
  },
  message: {
    userNameLength: "用户名长度在 5 到 20 个字符",
    resetPasswordConfirmation: "你确定要重置 '{val}' 客服密码吗？",
  },
  form: {
    userName: "客服",
    roleId: "角色",
    tag: "标签",
  },
};
